import i18n from '@/i18n';

// 创建一个可以在任何地方使用的翻译函数
export function translate(key: string): string {
  const i18nInstance = (window as any).i18nInstance || i18n;
  if (i18nInstance && i18nInstance.global && typeof i18nInstance.global.t === 'function') {
    const translation = i18nInstance.global.t(key);
    // 如果翻译结果和键名相同，说明没有找到对应翻译
    if (translation !== key) {
      return translation;
    }
  }
  // 如果找不到翻译或者翻译失败，返回键名
  return key;
}